export default "__VITE_PUBLIC_ASSET__139cf47b__"